import api from "./api";

export async function fetchProducts(collection, limit = 20) {
  const params = {};
  if (collection) params.collection = collection;
  if (limit) params.limit = limit;
  const { data } = await api.get("/shop/products", { params });
  return data;
}

export async function fetchProduct(handle) {
  const { data } = await api.get(`/shop/products/${handle}`);
  return data;
}

export async function createShopifyCart(lines = []) {
  const { data } = await api.post("/shop/cart", { lines });
  return data;
}

export async function getShopifyCart(cartId) {
  const { data } = await api.get(`/shop/cart/${encodeURIComponent(cartId)}`);
  return data;
}

export async function addToShopifyCart(cart_id, merchandiseId, quantity = 1) {
  const { data } = await api.post("/shop/cart/add", {
    cart_id,
    lines: [{ merchandiseId, quantity }],
  });
  return data;
}

export async function updateShopifyCart(cart_id, line_id, quantity) {
  const { data } = await api.post("/shop/cart/update", { cart_id, line_id, quantity });
  return data;
}

export async function removeShopifyCart(cart_id, line_ids) {
  const { data } = await api.post("/shop/cart/remove", { cart_id, line_ids });
  return data;
}
